{
  "adminSignInLink": {
    "body": "Нажмите кнопку ниже, чтобы получить доступ к панели администратора Pointcare.",
    "cta": "Вход в администрацию",
    "greeting": "Здравствуйте,",
    "ignore": "Если вы не запрашивали доступ администратора, вы можете проигнорировать это письмо.",
    "linkFallback": "Если кнопка не работает, скопируйте и вставьте эту ссылку:",
    "signoff": "Спасибо,\nКоманда Pointcare",
    "subject": "Ваша ссылка входа администратора Pointcare"
  },
  "reset": {
    "body": "Мы получили запрос на сброс пароля вашей учётной записи Pointcare. Нажмите кнопку ниже, чтобы создать новый пароль.",
    "cta": "Сбросить пароль",
    "greeting": "Здравствуйте,",
    "ignore": "Если вы не отправляли этот запрос, просто проигнорируйте это письмо. Ваш пароль не изменится.",
    "signoff": "Спасибо,\nКоманда Pointcare",
    "subject": "Сброс пароля Pointcare"
  },
  "signInLink": {
    "body": "Нажмите кнопку ниже, чтобы подтвердить адрес электронной почты и настроить учётную запись Pointcare.",
    "cta": "Подтвердить эл. почту",
    "greeting": "Здравствуйте,",
    "ignore": "Не регистрировались в Pointcare? Вы можете проигнорировать это письмо.",
    "linkFallback": "Если кнопка не работает, скопируйте и вставьте эту ссылку:",
    "signoff": "Спасибо,\nКоманда Pointcare",
    "subject": "Подтвердите адрес электронной почты для Pointcare"
  }
}
